import { render, staticRenderFns } from "./StationItem.vue?vue&type=template&id=cf4c163a&scoped=true"
import script from "./StationItem.vue?vue&type=script&lang=js"
export * from "./StationItem.vue?vue&type=script&lang=js"
import style0 from "./StationItem.vue?vue&type=style&index=0&id=cf4c163a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4c163a",
  null
  
)

export default component.exports